<script setup>
import CodeBlock from '@/assets/js/src/modules/webmasters/_components/CodeBlock.vue'
import { useTranslation, } from '@/assets/js/src/util/composables'

defineProps({
    code: {
        type: String,
        default: '',
    },
    languages: {
        type: String,
        default: '',
    },
})

const { t, } = useTranslation()
</script>

<template>
    <div>
        <h2 class="mt-5 mb-2">
            {{ t('async.webmasters.server_links.heading') }}
        </h2>
        <div v-html="t('async.webmasters.server_links.text',{'languages': languages})"></div>
        <code-block
            language="php"
            :code="code"
        ></code-block>
        <p>
            {{ t('async.webmasters.server_links.result_heading') }}
        </p>
        <div v-html="t('async.webmasters.server_links.result')"></div>
    </div>
</template>
